import { extend, override, } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import SettingsPage from 'flarum/forum/components/SettingsPage';
import LogInModal from 'flarum/forum/components/LogInModal';

const LoginEndpoint = (origin, path) => {
    return `${origin}/login?reload=1&referPath=${path}`
}

app.initializers.remove('flarum.update.routes');

app.initializers.add('insights-gaming-login-redirect', () => {
    override(LogInModal.prototype, 'content', (items) => {
        return [
            <div style="text-align: center; width: 90%; margin-left: 5%;padding-bottom:10%;">
                <div style="padding-bottom:25px">You can't create posts or respond to posts without being logged in to Insights.gg~ Click the button below to login to your Insights.gg Account!</div>
                <button
                    id="insights-gaming-alt-login-button"
                    class='Button Button--primary'
                >
                    Login or Signup
                </button>
            </div>
        ];
    });


    override(LogInModal.prototype, 'onsubmit', (e) => {
        window.location.href = LoginEndpoint(window.location.origin, window.location.pathname);
        e.preventDefault();
    });

    override(LogInModal.prototype, 'title', (items) => {
        return "You're not logged in D:";
    });

    extend(HeaderSecondary.prototype, 'items', (buttons) => {
        document.addEventListener("DOMContentLoaded", () => {
            if (document.getElementById("insights-gaming-login-button")) {
                document.getElementById("insights-gaming-login-button").onclick = () => window.location.href = LoginEndpoint(window.location.origin, window.location.pathname);
            }

            if (document.getElementById("insights-gaming-alt-login-button")) {
                document.getElementById("insights-gaming-alt-login-button").onclick = () => window.location.href = LoginEndpoint(window.location.origin, window.location.pathname);
            }
        });

        buttons.replace('logIn',
            <a classame="Button Button--link" id="insights-gaming-login-button">
                Login or Sign Up
            </a>
        );
        buttons.remove('signUp');
    });



    extend(SettingsPage.prototype, 'settingsItems', (items) => {
        // Remove change email and password buttons
        items.remove('account');
        // items.remove('changePassword');
    });

    // extend(SettingsPage.prototype, 'settingsItems', (items) => {
    //     if (setting('manage_account_url')) {
    //         return;
    //     }

    //     // Remove account section
    //     if (items.has('account') && items.get('account').children.length === 0) {
    //         items.remove('account');
    //     }
    // });
})
    ;
